// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"769px","tabletBreakpoint":"1280px","digiTime":"400"};